var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"hidden","id":'field-' + _vm.options.id,"name":'fields[' + _vm.options.id + ']'},domProps:{"value":_vm.options.preset_value}})
}
var staticRenderFns = []

export { render, staticRenderFns }